import { Store } from '@tanstack/react-store';

// You can use @tanstack/store outside of React components too!
export const galleryStore = new Store({
    open: false,
    imageActive: 0,
    images: [],
});
